<nav class="bottomnav" aria-label="<%= _lcs( 'Hauptnavigation' ) %>">
  <% tabs.forEach( function( t ) { %>
    <button class="bottomnav__item" type="button" data-tab="<%= t.id %>" data-route="<%= t.route %>">
      <span class="bottomnav__glyph">
        <i class="icon icon--<%= t.icon %> bottomnav__icon"></i>
        <!-- "There is an answer" and nothing more: a count would invite a guest
             to read a number instead of the message. Rendered on every tab but
             only ever shown on one (see setUnread). -->
        <span class="bottomnav__dot" data-id="dot-<%= t.id %>" hidden></span>
      </span>
      <span class="bottomnav__label"><%= _lcs( t.label ) %></span>
    </button>
  <% } ); %>
</nav>
